var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{class:_vm.$style.container},[_c('v-progress-circular',{attrs:{"color":"red","indeterminate":""}}),_c('div',{class:_vm.$style.caption},[_vm._t("default")],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }